import React from 'react';
import { Avatar, Flex, Typo } from '../../../ui';
import { useTasks } from '../hooks/useTasksState';
import AnswerStatusIcon from './AnswerStatusIcon';
import TaskModal from './TaskModal';
import ContentWrapper from './ContentWrapper';
import { useTranslation } from 'react-i18next';

const TasksByUser = ({ userTasks, open, handleClose, courseId }) => {
  const { t } = useTranslation();

  //userTasks and allTasks may appear to be the same but in some situations they are not.
  const { tasks: allTasks = [], isError, isLoading } = useTasks({ courseId }, { skip: !courseId });

  const getQuestion = (task) => {
    const question = allTasks.find((item) => +item.id === +task.id);
    return question?.question?.replace(/\[.*?\]/g, '').trim();
  };

  return (
    <TaskModal
      open={open}
      onClose={handleClose}
      title={
        <Flex gap='10' width='100%'>
          <Avatar size='small' name={userTasks?.name} url={userTasks?.avatar} hasBadge />
          <Typo.TextTitle>{userTasks?.name}</Typo.TextTitle>
        </Flex>
      }
    >
      {isError && !isLoading ? (
        <Flex width='100%'>
          <Typo.Info>{t('globals.genericError')}</Typo.Info>
        </Flex>
      ) : !userTasks && !isLoading ? (
        <Flex width='100%'>
          <Typo.Info>{t('tasks.noUsersResults')}</Typo.Info>
        </Flex>
      ) : (
        !!userTasks &&
        Object.values(userTasks?.tasks).map((task) => {
          return (
            <ContentWrapper key={task.id + 'accordion'} item={task} userName={userTasks.name} courseId={courseId} taskType={task.type}>
              <Flex gap='10' width='100%'>
                <AnswerStatusIcon grade={task.lastAnswerGrade} taskType={task.type} />
                <Flex direction='column' align='flex-start'>
                  <Typo.TextTitle>{getQuestion(task)}</Typo.TextTitle>
                  <Typo.Info>
                    {t(`tasks.${task.lastUpdate.type === 'response' ? 'responseSubmitted' : 'feedbackGiven'}`)}: {task.lastUpdate.date}
                  </Typo.Info>
                </Flex>
              </Flex>
            </ContentWrapper>
          );
        })
      )}
    </TaskModal>
  );
};

export default TasksByUser;
